<template>
  <div>
    <button ref="burger" class="burger flex flex-col h-full w-full justify-between" :class="burgerOpen ? 'burger--is-open' : ''">
      <div class="burger__item burger__item--first w-full h-[11%]" :class="bgColor" :style="firstStyle"></div>
      <div class="burger__item burger__item--middle w-full h-[11%]" :class="bgColor"></div>
      <div class="burger__item burger__item--last w-full h-[11%]" :class="bgColor" :style="lastStyle"></div>
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  bgColor: string
  open: boolean
}>()

const burger = ref<any>(null)
const burgerOpen = ref<boolean>(false)
const firstStyle = ref<CSSStyleValue>({})
const lastStyle = ref<CSSStyleValue>({})

watch(
  () => props.open,
  (newValue) => {
    newValue ? (burgerOpen.value = true) : (burgerOpen.value = false)
    const height = burger.value.offsetHeight * 0.45
    firstStyle.value = burgerOpen.value ? { transform: `translate(0, ${height}px) rotate(45deg)` } : {}
    lastStyle.value = burgerOpen.value ? { transform: `translate(0, ${-height}px) rotate(-45deg)` } : {}
  }
)
</script>

<style scoped>
.burger {
  &__item {
    transition:
      transform 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95),
      opacity 300ms linear;

    &--middle {
      .burger--is-open & {
        opacity: 0;
      }
    }
  }
}
</style>
